// Texty patičky — slovenské dvojče locale/cs/siteFooter.js.

export default {
  ig: {
    titleBefore: 'O ponukách informujeme vždy ',
    titleAccent: 'ako prví',
    titleAfter: ' na našom profile',
    cta: 'Sledujte náš Instagram',
  },
  brandsLabel: 'Značky u nás:',
  colInfo: {
    eyebrow: 'Informácie',
    title: 'Informácie pre vás',
    contact: 'Kontakty',
    shipping: 'Doprava a platba',
    claims: 'Reklamácie a vrátenie tovaru',
    withdrawal: 'Odstúpenie od zmluvy do 14 dní',
    terms: 'Obchodné podmienky',
    privacy: 'Ochrana osobných údajov',
    ratings: 'Hodnotenie obchodu',
  },
  colFirma: {
    eyebrow: 'Jipos',
    title: 'O firme',
    // SK: neověřeno ve fixtures — SK nemá kamennú predajňu, `page('store')`
    // vrací null a odkaz se přes withPages() vynechá; text zůstává pro jistotu.
    store: 'Predajňa náradia Bílina',
    b2b: 'Veľkoobchod (B2B)',
    news: 'Aktuality',
    brands: 'Značky',
    contact: 'Kontakty',
  },
  colRadce: {
    eyebrow: 'Poradňa',
    title: 'Nákupný radca',
    tips: 'Rady a tipy',
    inspiration: 'Inšpirácia',
    service: 'Servis a náhradné diely',
    orderStatus: 'Stav objednávky',
    claimForm: 'Reklamačný formulár',
    account: 'Váš zákaznícky účet',
  },
  service: {
    eyebrow: 'Podpora',
    title: 'Zákaznícky servis',
    lead: 'Poradíme vám',
    leadMore: ' s výberom',
    sub: 'Sme tu pre vás',
  },
  newsletter: {
    eyebrow: 'Newsletter',
    title: 'Prihláste sa na odber noviniek',
    desc: 'Získajte tipy, akcie a informácie o novom náradí – stačí zadať e-mail.',
    placeholder: 'Váš e-mail',
    submit: 'Odoberať',
    socialLabel: 'Sledujte nás na sociálnych sieťach:',
  },
  sign: {
    // SK: neověřeno ve fixtures — zachycený dev/sk/home.html už nesl náš
    // vlastní zápis „Běží na" (česky), ne nativní slovenský text Shoptetu.
    // „Vytvoril" je běžný slovenský tvar odpovídající CZ „Vytvořil".
    nativeFrom: 'Vytvoril',
    nativeTo: 'Beží na',
    sep: ' · ',
    label: 'Shoptet šablóny na mieru khoder.cz',
  },
  legal: {
    privacy: 'Zásady spracovania osobných údajov',
    terms: 'Obchodné podmienky',
    aria: 'Právne informácie',
  },
};
